import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';

function InputPhoneNumber({ value, onChange, placeholder, disabled }) {
  const [localDigits, setLocalDigits] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const raw = value !== undefined ? value : localDigits;
  const digits = raw.replace(/\D/g, '').slice(0, 10);

  const handleChange = (e) => {
    let onlyDigits = e.target.value.replace(/\D/g, '');
    if (onlyDigits.startsWith('0')) {
      onlyDigits = onlyDigits.slice(1);
    }
    if (onlyDigits.length > 10) {
      onlyDigits = onlyDigits.slice(0, 10);
    }
    if (value === undefined) {
      setLocalDigits(onlyDigits);
    }
    onChange && onChange(onlyDigits);
  };

  const formatNumber = (d) => {
    const p1 = d.slice(0, 3);
    const p2 = d.slice(3, 6);
    const p3 = d.slice(6, 10);
    let formatted = '';
    const closingParen = p1.length === 3 ? ')' : '';
    const space = p1.length === 3 ? ' ' : '';
    const dash = p2.length === 3 ? '-' : '';

    if (p1) {
      formatted = `(${p1}${closingParen}`;
    }
    if (p2) {
      formatted = `${formatted}${space}${p2}`;
    }
    if (p3) {
      formatted = `${formatted}${dash}${p3}`;
    }
    return formatted;
  };

  return (
    <Input
      disabled={disabled}
      prefix={
        <>
          <PhoneOutlined style={{ marginRight: 4 }} />
          <span>+90</span>
        </>
      }
      // Odakta ham rakam, blur’da formatlı göster
      value={isFocused ? digits : formatNumber(digits)}
      onChange={handleChange}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      placeholder={placeholder}
      allowClear
    />
  );
}

InputPhoneNumber.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

InputPhoneNumber.defaultProps = {
  placeholder: '(5xx) xxx-xxxx',
};

export default InputPhoneNumber;
